<script setup lang="ts">
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmSpinner,
} from "tir-components";
import { TirPmIconView } from "tir-pm-icon-view";
import { ChartBarIcon } from "tir-style-system/icons/outline";
import { ArrowPathIcon } from "tir-style-system/icons/solid";

/**События */
const emit = defineEmits<{
  /**Событие переподключения */
  reconnect: [];
}>();

/**Переподключится */
const reconnect = () => {
  emit("reconnect");
};
</script>

<template>
  <div class="notification-reconnected__block">
    <TirPmIconView
      :isBordered="false"
      class="notification-reconnected__logo"
      colorCode="transparent"
      :size="40"
    >
      <template #mainSlot>
        <svg
          :style="{ width: '40px', height: '40px' }"
          viewBox="0 0 44 20"
          fill="red"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.20076 19.5H8.37724L13.3849 5.02381H21L22.5754 0.5H2.13171L0.5 5.02381H8.2647L3.20076 19.5Z"
          />
          <path
            d="M29.697 4.99402L41.9246 5L43.5 0.5H26.468C24.9951 0.5 24.0887 1.18264 23.7488 2.6048C23.6921 2.71857 23.069 4.53893 21.8793 8.06587C21.7094 8.57785 21.5961 9.03294 21.5961 9.48803C21.5961 11.2949 23.2611 12.1617 24.8818 12.1617H33.4926C34.2857 12.1617 34.5 12.488 34.5 13C34.5 14.5 33.3633 15.006 32.303 15.006H20.0862L18.5 19.5H35.532C37.0196 19.5 37.6843 18.5907 38.2512 17.3383C38.2512 17.3383 40.5 12.1617 40.6305 10.2275C40.7611 8.29341 38.9737 7.61077 37.3448 7.61077H28.734C27.9975 7.61077 27.6576 7.38324 27.6576 6.92815C27.6576 6.30381 27.7731 5.71312 28.3374 5.33533C28.6773 5.10778 29.1305 4.99402 29.697 4.99402Z"
          />
        </svg>
      </template>
    </TirPmIconView>

    <div class="notification-reconnected__information">
      <ChartBarIcon class="notification-reconnected__icon" />
      <div class="notification-reconnected__message">Нет соединения</div>
      <TirPmButton
        class="notification-reconnected__button"
        :variant="TirPmButtonVariantEnum.LinkState"
        :size="TirPmButtonSizeEnum.Small"
        @click="reconnect"
      >
        <template #leftSlot>
          <ArrowPathIcon />
        </template>
        Попробовать снова
      </TirPmButton>
    </div>
  </div>
</template>

<style scoped lang="scss">
.notification-reconnected {
  &__block {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    padding: 0.625rem 2.25rem 0.625rem 2.25rem;
    background-color: var(--bg-negative, #ffebeb);
  }
  &__icon {
    width: 1rem;
    height: 1rem;
  }
  &__disconnected {
    color: var(--text-negative);
    background-color: var(--bg-negative);
  }
  &__button {
    margin-left: 0.75rem;
  }
  &__logo {
    background: none;
  }

  &__information {
    display: flex;
    align-items: center;
    margin-left: 0.75rem;
    color: var(--text-negative, #ec2e14);
  }

  &__message {
    margin-left: 0.25rem;
  }
}
</style>
